import styled from 'styled-components';

export const Spacer = styled.div`
  margin: 10px 0px;
  width: 100%;
`;
